export enum JoystickShape {
    Circle = 'circle',
    Square = 'square'
}